import type { Route } from "@types";
import { Stake } from "../sections/Stake";
import { Bars } from "../sections/Bars";
import { Play } from "../sections/Play";
// import { Stats, } from "../sections/Stats";
import { FAQ } from "../sections/FAQ";

import * as IC from "../assets/icons";

export const routes: Route[] = [
  {
    name: "default",
    route: "/",
    description: "",
    weight: 50,
    component: Stake,
    icon: IC.StackAndBall,
  },
  {
    name: "Stake",
    route: "/stake",
    description: "",
    weight: 50,
    component: Stake,
    icon: IC.StackAndBall,
  },
  {
    name: "Bars",
    route: "/bars",
    description: "",
    weight: 40,
    component: Bars,
    asset: "/assets/bracket-gold-bars.png",
  },
  {
    name: "Analytics",
    route: "https://dune.com/bracket/staking",
    description: "",
    weight: 30,
    component: () => <div></div>,
    icon: IC.ChartLine,
    isExternal: true,
  },
  {
    name: "Play",
    route: "/play",
    description: "",
    weight: 1,
    component: Play,
    icon: IC.PlayIcon,

    // TODO: remove on game day
    disabled:
      window.location.search.includes("feature=in-out") ||
      Math.floor(Date.now() / 1000) >= 1726059600
        ? false
        : true,
  },
  {
    name: "FAQ",
    route: "/faq",
    description: "",
    weight: 10,
    component: FAQ,
    icon: IC.CircledQuestion,
  },
  {
    name: "Referrals",
    route: "/referrals",
    description: "",
    weight: 10,
    component: FAQ,
    icon: IC.TriWork,
  },
];
